import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconWorld from '@/icons/World.svg';
import { AGREEMENT_TYPE_LABELS } from '@/models/agreements';

import { useFilters } from '../FiltersState';

export const MobileFiltersAgreementType = () => {
  const { t, i18n } = useLingui();

  const {
    agreementTypes: { agreementTypes, setAgreementTypes },
  } = useFilters();

  const toggleType = (id: string) => {
    const typed = id as 'price_catalog' | 'transit' | 'after_sales';

    if (agreementTypes.includes(typed)) {
      setAgreementTypes(agreementTypes.filter((x) => x !== typed));
    } else {
      setAgreementTypes([...agreementTypes, typed]);
    }
  };

  const options = AGREEMENT_TYPE_LABELS.map(({ id, label }) => (
    <FilterCheckboxItem key={id} id={id} label={i18n._(label)} />
  ));

  return (
    <FiltersSubMenu
      id="agreement-type"
      icon={<IconWorld />}
      label={t({
        id: 'settings.organization.entities.agreements.filters.type.label',
        message: 'Type',
      })}
      count={agreementTypes.length}
    >
      <FiltersList
        ariaLabel={t({
          id: 'settings.organization.entities.agreements.filters.type.label',
          message: 'Type',
        })}
        values={agreementTypes}
        onChange={toggleType}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
